// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__ObDs1","clinicsSelect":"TableHeading_clinicsSelect__1gqgF"};